import anime from "animejs";

/* custom imports */
import { fadeIn, fadeOut } from '.././animation/menu.js';
import {revealVideo} from "../animation/video";

/** ----------------------------------------
     Mobile Menu
 ---------------------------------------- */

/**
 * This class will handle the toggle of the
 * mobile menu.
 */

export class MobileMenu {

    /**
     * @init            calls the init method
     */

    constructor() {
        this.init();
    }

    /** ----------------------------------------
        Merge Settings
     ---------------------------------------- */

    mergeSettings(obj1, obj2) {
        return Object.assign(obj1, obj2);
    }

    /** ----------------------------------------
        Toggle State
     ---------------------------------------- */

    toggleAcitve(element) {
        document.body.classList.toggle('is-locked');
        element.classList.toggle('is-active');
    }

    /** ----------------------------------------
        Menu Event
     ---------------------------------------- */

    menuEvent() {
        let hamburger = document.querySelector('.nav__hamburger');
        let mobileMenu = document.querySelector('.menu--mobile');

        if(hamburger)
            hamburger.addEventListener('click', (e) => {
                e.target.classList.contains('is-active') ? this.closeMenu(mobileMenu) : this.openMenu(mobileMenu);
                this.toggleAcitve(e.target);
            });
    }

    openMenu(element) {
        element.style.display = 'block';

        let animation = this.mergeSettings({ targets: element }, fadeIn);
        let reveal = anime(animation);
    }

    closeMenu(element) {
        let animation = this.mergeSettings({ targets: element }, fadeOut);
        let close = anime(animation);

        close.finished.then(() => {
            element.style.display = 'none';
        });
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    /**
     * This function is called within the
     * constructor and will initiate once the
     * class is loaded.
     */

    init() {
        this.menuEvent();
    }

}